import api from '@/services/api'
import store from '../index'

export default {
  state: {},

  mutations: {},

  actions: {
    async getClient({ commit }) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateClient({ commit }, client) {
      try {
        return await api.put(`/${client.id}`, client)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
